export const environment = {
  firebase: {
    projectId: 'dc3-alpha',
    appId: '1:1018785083154:web:c7a4ae90c14ddda0088dcb',
    storageBucket: 'dc3-alpha.appspot.com',
    locationId: 'europe-west3',
    apiKey: 'AIzaSyDaADH1wMOb1O7X-r6GoAPtbAt6hf6yOD4',
    authDomain: 'dc3-alpha.firebaseapp.com',
    messagingSenderId: '1018785083154',
    measurementId: 'G-KGTYJBRDHK',
  },
  useEmulators: false,
  production: true,

  supabase: {
    url: 'https://ikfnbxiwrfwlstqmbhtt.supabase.co',
    key: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlrZm5ieGl3cmZ3bHN0cW1iaHR0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mjg4MDYxNjYsImV4cCI6MjA0NDM4MjE2Nn0.FV72ifZueITjQd4ShEdpXwJZ4tWhnHLICn8VUfojIEE'
  },

  syncUpDebounceMilliseconds: 0,
  elfPersistence: false,
};
